import {
    Component,
    OnInit,
    Input,
    ViewChild,
    TemplateRef,
    Output,
    EventEmitter
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { CommonService } from '../../services/index';
@Component({
    selector: 'trailModelDet-tab',
    templateUrl: './trailModalDet.component.html'
})
export class trailModelDetComponent {
    data: any;
    dataval: any;
    columns: any;
    clientdata: any;
    clientdatacnt: any;
    servicedata: any;
    servicecolumns: any;
    servicecnt: any;
    machinedata: any;
    machinecolumns: any;
    machinecnt: any;
    sparedata: any;
    sparecolumns: any;
    sparecnt: any;
    isLoadMask: Promise<any>;
    @Input() set showModelHistory(val: any) {
        this.data = val;
        if (this.data) {
            let that = this;
            this.isLoadMask = that.commonService
                .getModelHistory(that.data)
                .then(function (res: any) {
                    that.clientdata = res.data;
                });
        }
    }

    constructor(public commonService: CommonService, public bsModalRef: BsModalRef, private modalService: BsModalService) {

    }
    ngOnInit(): void {


        this.columns = [
            {
                name: "Model Name",
                prop: "model_name",
                width: 200,
                minWidth: 200,
                maxWidth: 200,
                toggle: true
            },
            {
                name: "MRP",
                prop: "mrp",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Brand Name",
                prop: "brand_name",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Brand Model Name",
                prop: "brand_model_name",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Family Name",
                prop: "family_name",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Series Name",
                prop: "series_name",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Power Name",
                prop: "power_name",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Performance Name",
                prop: "performance_name",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Battery Name",
                prop: "battery_name",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Color",
                prop: "color_name",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            },
            {
                name: "Tele Audiology",
                prop: "tele_audiology",
                sortable: false,
                width: 200,
                minWidth: 200,
                maxWidth: 200
            }

        ];

    }
    ngAfterViewInit() {

    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/trailModalDet.component.ts